import { createContext } from 'react';
import type {
  SegmentButtonPosition,
  SegmentButtonSize,
  SegmentButtonVariants,
} from './SegmentButton/SegmentButton.types';

type SegmentedButtonContextType = {
  onChange: (selected: string) => void;
  size?: SegmentButtonSize;
  position?: SegmentButtonPosition;
  variant?: SegmentButtonVariants;
  selectedButtons: string[];
};

const defaultContext: SegmentedButtonContextType = {
  selectedButtons: [],
  onChange: () => {},
};

export const SegmentedButtonContext =
  createContext<SegmentedButtonContextType>(defaultContext);
